import { useNavigateToAdvancedEditor } from '@/hooks/navigation';
import AccountMerged from '@/pages/post-sso/components/AccountMerged';
import { useAnalytics, useIdentifyUser } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import { AppRoutes } from '@/utils/types';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ACCOUNT_MERGED = 'account_merged';

interface Props {
    redirectUri?: string;
}
export default function ({ redirectUri }: Props) {
    const { user } = useAuth();
    const mixpanel = useAnalytics();
    const navigate = useNavigate();
    const identifyUser = useIdentifyUser();
    const { navigateToAdvancedEditor } = useNavigateToAdvancedEditor();
    const [searchParams] = useSearchParams();
    const { loading, userSettings } = useUserSettings();
    const accountMerged = searchParams.get(ACCOUNT_MERGED) || searchParams.get('error_description') === ACCOUNT_MERGED;

    useEffect(() => {
        const url = new URL(window.location.href);
        const from = url.searchParams.get('from');
        const merged = url.searchParams.get(ACCOUNT_MERGED) || url.searchParams.get('error_description') === ACCOUNT_MERGED;

        if (mixpanel && user && !loading) {
            identifyUser(user);
            mixpanel.enrich({
                isAnonymous: user.isAnonymous,
                currentPlan: user.planGroup,
                currentBilling: user.billingInterval,
                editorVersion: userSettings?.features?.editor?.version,
            });

            if (user.isNew) {
                mixpanel.track('signup', { event: 'view' });
            } else {
                mixpanel.track('login', { event: 'view' });
            }
        }

        if (merged) {
            return;
        }

        if (from === 'advanced') {
            navigateToAdvancedEditor({ from });
        } else {
            navigate(AppRoutes.Home);
        }
    }, []);

    if (accountMerged) {
        return <AccountMerged redirectUri={redirectUri} />;
    }

    return null;
}
